module.exports = __webpack_public_path__ + "assets/img/mecha-0e461d28.png";